import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { XpressUserProfile } from 'app/models';
import { RiderService } from 'app/services';
import { DomSanitizer } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { UploadDocumentModalComponent } from 'app/components/modals/upload-document-modal/upload-document-modal.component';

@Component({
  selector: 'document-image',
  templateUrl: './document-image.component.html',
  styleUrls: ['./document-image.component.scss']
})
export class DocumentImageComponent implements OnInit {

@Input()
    public profile: XpressUserProfile = new XpressUserProfile();
@Input()
    public initialProfile: XpressUserProfile = new XpressUserProfile();

@Output()
    public updateUserProfile = new EventEmitter<XpressUserProfile>();

  //start galleria
  public infoItems: any = [];
  public activeImgIndex: number = 0;
  public displayImg: boolean = false;
  public imageOptions: any[] = [
      {
          breakpoint: '1500px',
          numVisible: 5
      },
      {
          breakpoint: '1024px',
          numVisible: 3
      },
      {
          breakpoint: '768px',
          numVisible: 2
      },
      {
          breakpoint: '560px',
          numVisible: 1
      }
  ];

  public showPhotoImageModal() {
    this.infoItems = [{ value: this.profile.ImageUrl}];
    this.displayImg = true;
  }
  //end galleria

  //DocsGalleries
  public govIdsImgs: any = [];
  public DTIImgs: any = [];
  public BIRImgs: any = [];
  public LTFRBImgs: any = [];
  public PermitImgs: any = [];

  public activeGovIdImgIndex: number = 0;
  public activeDTIImgIndex: number = 0;
  public activeBIRImgIndex: number = 0;
  public activeLTFRBImgIndex: number = 0;
  public activePermitImgIndex: number = 0;

  public govIdsVisible: boolean = false;
  public DTIVisible: boolean = false;
  public BIRVisible: boolean = false;
  public LTFRBVisible: boolean = false;
  public PermitVisible: boolean = false;
  public showUploadDocumentsPopup: boolean = false;
  public discardConfirmDialog: boolean = false;

  @ViewChild(UploadDocumentModalComponent)
  private uploadModal?: UploadDocumentModalComponent;
  public imageUrlArray: any[] = [];
  public docURL: string[] = [];
  public isPdfDoc: boolean = false;
  public isDocsShown: boolean = false;

  constructor(
      private sanitizer: DomSanitizer,
      private riderService: RiderService,
      private messageService: MessageService,
        ) {
    }

  ngOnInit(): void {
    this.initGalleriesImages();
  }

  public restoreDocumentsFromInitial(): void {
    this.copyDocumentUrls(this.initialProfile, this.profile);
    this.initGalleriesImages();
  }

  public applySavedDocuments(): void {
    this.copyDocumentUrls(this.profile, this.initialProfile);
    this.initGalleriesImages();
  }

  private copyDocumentUrls(from: XpressUserProfile, to: XpressUserProfile): void {
    to.GovIdUrls = [...(from.GovIdUrls || [])];
    to.DTIorSECCertifUrls = [...(from.DTIorSECCertifUrls || [])];
    to.BIRCertifUrls = [...(from.BIRCertifUrls || [])];
    to.LTFRBCertifUrls = [...(from.LTFRBCertifUrls || [])];
    to.BusinessPermitUrls = [...(from.BusinessPermitUrls || [])];
    to.GovIdData = [...(from.GovIdData || [])];
    to.DTIorSECCertifData = [...(from.DTIorSECCertifData || [])];
    to.BIRCertifData = [...(from.BIRCertifData || [])];
    to.LTFRBCertifData = [...(from.LTFRBCertifData || [])];
    to.BusinessPermitData = [...(from.BusinessPermitData || [])];
  }

  public initGalleriesImages() {
    this.imageUrlArray = [];
    this.imageUrlArray.push({url: this.profile.BIRCertifUrls[0], name: 'BIRPdfUrl'}, {url: this.profile.BusinessPermitUrls[0], name: 'BusinessPermitPdfUrl'},
        {url: this.profile.DTIorSECCertifUrls[0], name: 'DTIorSECPdfUrl'}, {url: this.profile.LTFRBCertifUrls[0], name: 'LTFRBPdfUrl'},
        {url: this.profile.GovIdUrls[0], name: 'GovPdfUrl'});
    this.imageUrlArray.map(i => {
        this.isPdf(i.url).then(res => {
            i.isPdf = res;
            i.safeUrl = this.getSafeUrl(i.url);
        });
    });
    this.profile.BIRPdfUrl = this.getSafeUrl(this.profile.BIRCertifUrls[0]);
    this.profile.BusinessPermitPdfUrl = this.getSafeUrl(this.profile.BusinessPermitUrls[0]);
    this.profile.DTIorSECPdfUrl = this.getSafeUrl(this.profile.DTIorSECCertifUrls[0]);
    this.profile.LTFRBPdfUrl = this.getSafeUrl(this.profile.LTFRBCertifUrls[0]);
    this.profile.GovPdfUrl = this.getSafeUrl(this.profile.GovIdUrls[0]);
  }

  public showDocs(docs: any){
    this.isDocsShown = true;
    this.isPdfDoc = docs.isPdf;
    if(docs.isPdf){
        this.docURL = [docs.safeUrl];
    }
  }

  reset(){
    this.isDocsShown = false;
    this.isPdfDoc = false;
  }

  toggleUploadPopup() {
    this.showUploadDocumentsPopup = true;
    this.profile = this.profile;
  }

  closeUploadPopup(discardRequested: boolean) {
    if (discardRequested) {
      this.discardConfirmDialog = true;
      return;
    }
    this.showUploadDocumentsPopup = false;
  }

  updateProfile(event: XpressUserProfile) {
    this.showUploadDocumentsPopup = false;
    this.updateUserProfile.emit(event);
  }

  public hideConfirmModal(keepUploadOpen: boolean) {
    this.discardConfirmDialog = false;
    if (keepUploadOpen) {
      this.uploadModal?.clearDiscardRequest();
      this.showUploadDocumentsPopup = true;
      return;
    }
    this.uploadModal?.confirmDiscard();
    this.restoreDocumentsFromInitial();
    this.showUploadDocumentsPopup = false;
  }

  getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
 }

  isPdf(url: string): Promise<boolean> {
    if (url) {
        const dto = {
            Url: url
        };

        return this.riderService.getContentTypeByImageUrl(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    console.log(data.ErrorMessage);
                    return false;
                }

                if (data.ContentType?.toLowerCase().includes('application/pdf')) {
                    return true;
                } else {
                    return false;
                }
                })
                .catch(err => {
                    console.log(err);
                    return false;
                });
        }
        return Promise.resolve(false);
    }
}
